/* HOT DOGUE · Galería por color: al elegir un color, la ficha enseña solo las fotos de ese color.
   Una foto pertenece a un color si su texto alternativo termina en "(Color)", p. ej. "… (Azul)"; "(Rojo)" sirve también para "Rojo con gorro". Las fotos sin color se ven siempre. */
(function () {
  function apply(gallery, variant) {
    var idx = parseInt(gallery.dataset.sdColorIndex, 10);
    var colors = (gallery.dataset.sdColors || '').split('|');
    if (isNaN(idx) || !variant || !variant.options) return;
    // En otros idiomas el botón viene traducido ("Red"); data-sd-map lo traduce a la etiqueta de las fotos ("Rojo").
    var map = {};
    (gallery.dataset.sdMap || '').split('|').forEach(function (p) { var kv = p.split('=>'); if (kv.length === 2) map[kv[0]] = kv[1]; });
    colors = colors.map(function (v) { return map[v] || v; }).concat(Object.keys(map).map(function (k) { return map[k]; }));
    var current = map[variant.options[idx]] || variant.options[idx];
    // "(Rojo)" vale para "Rojo" y para "Rojo con gorro"; "(Rojo con gorro)" solo para "Rojo con gorro".
    function fits(tag, value) { return value === tag || value.indexOf(tag + ' ') === 0; }
    function isTag(tag) { return colors.some(function (v) { return fits(tag, v); }); }
    var items = gallery.querySelectorAll('[data-sd-color]');
    var hasMatch = Array.prototype.some.call(items, function (el) { return fits(el.dataset.sdColor, current); });
    Array.prototype.forEach.call(items, function (el) {
      var tag = el.dataset.sdColor;
      el.classList.toggle('sd-color-hidden', hasMatch && isTag(tag) && !fits(tag, current));
    });
    var first = gallery.querySelector('.product__media-item:not(.sd-color-hidden)');
    if (first && gallery.setActiveMedia && first.dataset.mediaId) {
      try { gallery.setActiveMedia(first.dataset.mediaId, false); } catch (e) {}
    }
  }
  function currentVariant(info) {
    var json = info && info.querySelector('variant-selects [data-selected-variant]');
    try { return json ? JSON.parse(json.textContent) : null; } catch (e) { return null; }
  }
  function init() {
    document.querySelectorAll('media-gallery[data-sd-color-index]').forEach(function (g) {
      apply(g, currentVariant(g.closest('product-info') || document));
    });
  }
  document.addEventListener('DOMContentLoaded', init);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
      setTimeout(function () {
        document.querySelectorAll('media-gallery[data-sd-color-index]').forEach(function (g) { apply(g, e.data.variant); });
      }, 60);
    });
  }
})();
